<template>
  <div class="infos">
    <div class="city">
      <div class="logo"> <!-- Permet de définir l'espace occupé par le logo pendant le chargement de l'image -->
        <img :src="cityLogo" alt="Logo de la ville">
      </div>
      <h2>{{ cityName }}</h2>
    </div>
    <div class="message">
      <slot></slot>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    cityLogo: String,
    cityName: String
  }
}

</script>

<style scoped>
.infos .city {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 1.5rem;
  padding: 1.5rem 4rem;
  color: rgba(255, 255, 255, 0.9);
  background: #1d3f5f; /* IE */
  background: var(--primary-dark);
}

.infos .city div.logo {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 4.5rem;
  min-width: 4.5rem;
  max-width: 6.5rem;
  margin-right: 3%;
}

.infos .city img {
  max-height: 100%;
  max-width: 100%;
}

.infos .message {
  display: flex;
  flex-direction: column;
  align-items: left;
  margin-top: 2rem;
  padding: 3rem 4rem;
  font-size: 1.05rem;
  line-height: 1.7rem;
  background: rgba(0, 0, 0, 0.03);
}

.infos .message p {
  text-align: justify;
}

@media (max-width: 1000px) {
  .infos .city, .infos .message {
    margin-top: 0;
    padding: 1.5rem 2rem;
  }
}

/* IE10+ CSS styles */
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .infos .city, .infos .message {
    display: block;
    width: auto;
  }

  .infos .city div.logo {
    display: inline-block;
  }

}

@media (max-width: 1000px) and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .infos .city, .infos .message {
    margin: auto;
    max-width: 800px;
  }
}

@media (max-width: 800px) and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .infos .city, .infos .message {
    margin: auto;
    max-width: 600px;
  }
}

@media (max-width: 600px) and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .infos .city, .infos .message {
    margin: auto;
    max-width: 400px;
  }
}

@media (max-width: 400px) and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .infos .city, .infos .message {
    margin: auto;
    max-width: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CityInfosMessage.vue